import { render } from "./PantryIngredientView.vue?vue&type=template&id=7dc059c5&ts=true"
import script from "./PantryIngredientView.vue?vue&type=script&lang=ts"
export * from "./PantryIngredientView.vue?vue&type=script&lang=ts"

import "./PantryIngredientView.vue?vue&type=style&index=0&id=7dc059c5&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__